/**
 * Icon-chip tint classes shared by the launcher grid and the topbar's
 * module switcher — soft token fills with the darker ink of the same
 * ladder. Cosmetic grouping only; state is never encoded by color alone.
 */
import type { LauncherTint } from "./launcher-config.ts";

export const TINT_CLASS: Record<LauncherTint, string> = {
  sky: "bg-sky-100 text-sky-700",
  ok: "bg-ok-100 text-ok",
  warn: "bg-warn-100 text-warn",
  bad: "bg-bad-100 text-bad",
  slate: "bg-line text-ink-2",
  ai: "bg-sky-600 text-paper",
};
